import { useEffect, useState } from "react";

export function useDebouncedValue(value, delay = 300) {
  const [debounced, setDebounced] = useState(value);
  const [pending, setPending] = useState(false);
  useEffect(() => {
    if (Object.is(value, debounced)) {
      setPending(false);
      return undefined;
    }
    setPending(true);
    const timer = setTimeout(() => {
      setDebounced(value);
      setPending(false);
    }, delay);
    return () => clearTimeout(timer);
  }, [value, delay, debounced]);
  return [debounced, pending];
}
